/**
 * =====================================================
 * checkout.js
 * =====================================================
 *
 * Progetto: Ventura Shop
 * Tipo: Satellite JS
 * Dipendenza: main.js (namespace globale "ventura")
 *
 * Descrizione:
 * Questo file contiene tutte le logiche JS specifiche
 * per la pagina checkout. Si integra con il namespace
 * globale "ventura" definito in main.js.
 *
 * Note:
 * - Non dipendere da altri satelliti, solo da main.js
 * - Il caricamento condizionale avviene tramite la
 *   variabile globale `isTemplate` passata da PHP
 *   tramite WP_PARAMS.is_page_template.
 * - Tutte le funzioni dovrebbero essere incapsulate
 *   all'interno di ventura o di closure locali.
 *
 * Esempio di utilizzo:
 *   ventura.checkoutInit();
 *
 * =====================================================
 */
const ventura = window.ventura;
window.isTemplate = window.WP_PARAMS ? window.WP_PARAMS.is_page_template : null;

(function($) {
   if (isTemplate !== 'templ-checkout.php') return;

    ventura.openListProductsCheckout = function() {
        $(document).on("click", ".product-total-toggle", function () {
            $(".product-total-list").toggleClass('product-total-list--open');
        });
    }
    
    // Document ready per satellite
    $(document).on('venturaReady', function(){
        ventura.openListProductsCheckout();
    });

})(jQuery);
